import { combineReducers } from "redux";

import product_enquiry from "../features/admin/product_enquirys/product_enquiry/Slice";

import common from "../features/admin/common/Slice";

const product_enquirys = combineReducers({
    product_enquiry,
    common
});

export default product_enquirys;